import type { CSSProperties } from "react"

/** Тёмная тема Telegram: превью должно читаться как настоящий чат, а не как форма админки. */
export const TG = {
	wallpaper: "#0e1621",
	panel: "#17212b",
	incoming: "bg-[#182533]",
	outgoing: "bg-[#2b5278]",
	field: "bg-[#242f3d]",
}

export const WALLPAPER_STYLE: CSSProperties = {
	backgroundColor: TG.wallpaper,
	backgroundImage:
		"radial-gradient(circle at 12% 8%, rgba(70,130,190,0.16), transparent 42%), radial-gradient(circle at 88% 92%, rgba(70,130,190,0.12), transparent 48%)",
}

export const COMPOSER_ICON_CLASS =
	"grid h-10 w-10 shrink-0 place-items-center rounded-full text-white/55 transition-colors hover:bg-white/5 hover:text-white disabled:pointer-events-none disabled:opacity-40"

export const INLINE_BUTTON_CLASS =
	"flex min-w-0 flex-1 items-center justify-center gap-1.5 rounded-xl bg-[#1d2c3c]/90 px-2 py-2 text-[13px] font-medium text-white shadow-sm transition-colors hover:bg-[#25384c] disabled:opacity-50"

/** Цвета кнопок Telegram: primary: синяя, success: зелёная, danger: красная. */
export const STYLE_CLASSES = {
	primary: "bg-blue-600 hover:bg-blue-600/85",
	success: "bg-emerald-600 hover:bg-emerald-600/85",
	danger: "bg-red-600 hover:bg-red-600/85",
} as const

export const formatTime = (at: string) =>
	new Date(at).toLocaleTimeString("ru-RU", { hour: "2-digit", minute: "2-digit" })
